import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueLayers from "vuelayers";
import "vuelayers/dist/vuelayers.css";
import KeyboardEvents from "@/components/Common/KeyboardEvents";

Vue.use(VueLayers);

Vue.config.productionTip = false;

// Overall 하게 사용되는 component
Vue.component("KeyboardEvents", KeyboardEvents);

// Overall 하게 사용되는 함수 정의.
// 정의: utils/index.js
// 사용: this.$funcs.copy(value);
import { commonFunctions } from "@/utils/index.js";
Vue.prototype.$funcs = commonFunctions;

// Dragable
Vue.directive("draggable", {
  bind: function (el) {
    el.style.position = "absolute";
    var startX, startY, initialMouseX, initialMouseY;

    function mousemove(e) {
      var dx = e.clientX - initialMouseX;
      var dy = e.clientY - initialMouseY;
      el.style.top = startY + dy + "px";
      el.style.left = startX + dx + "px";
      return false;
    }

    function mouseup() {
      document.removeEventListener("mousemove", mousemove);
      document.removeEventListener("mouseup", mouseup);
    }

    el.addEventListener("mousedown", function (e) {
      startX = el.offsetLeft;
      startY = el.offsetTop;
      initialMouseX = e.clientX;
      initialMouseY = e.clientY;
      if (e.target.nodeName != "INPUT") {
        document.addEventListener("mousemove", mousemove);
        document.addEventListener("mouseup", mouseup);
      }
      return false;
    });
  },
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");

console.log("WMGIS V1.0.5");
